import { SUPPORTED_MIME_TYPES } from "../../../../static-data";

export const isAllowedMimeType = ({ file }) => {
  if (!(file instanceof Blob)) return false;
  if (typeof file.type !== "string") return false;
  return Object.values(SUPPORTED_MIME_TYPES).includes(file.type);
};
